import { useRef } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination, Navigation } from "swiper";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";

import { ChevronRightIcon } from "@qoohoo/common/library/Icons";
import TranslateAppear from "components/Animation/TranslateAppear";

function ReviewSection({ heading, items, theme }) {
  const previousArrow = useRef(null);
  const nextArrow = useRef(null);

  const pagination = {
    clickable: true,
    type: "bullets",
    bulletClass: "bullet-rectangle",
    bulletActiveClass: "bullet-rectangle-active",
    renderBullet: function (index, className) {
      return `<span class=${className}></span>`;
    },
  };

  return (
    <section className="px-1 py-9 md:py-[3.75rem] flex flex-col items-center justify-between gap-6 md:gap-9 relative">
      <TranslateAppear>
        <h1 className="font-bold text-2xl leading-normal md:text-[2.5rem] text-center">
          {heading}
        </h1>
      </TranslateAppear>

      <div className="flex items-center justify-between gap-2 md:gap-6 w-full mx-auto max-w-[69rem]">
        <div ref={previousArrow} className="cursor-pointer h-6 w-6 md:h-9 md:w-9 shrink-0 rotate-180">
          <ChevronRightIcon className="text-[#5C5E5F] stroke-current h-full w-full" />
        </div>
        <Swiper
          simulateTouch={false}
          slidesPerView={1}
          spaceBetween={16}
          navigation={{
            enabled: true,
            prevEl: previousArrow.current,
            nextEl: nextArrow.current,
          }}
          className="rounded-2xl reviews-swiper"
          pagination={pagination}
          modules={[Navigation, Pagination]}
          loop
          autoplay
        >
          {items.map((review, idx) => {
            const { creatorName, creatorImage, creatorReview, image } = review;
            return (
              <SwiperSlide
                className="!h-auto overflow-hidden"
                key={idx}
              >
                <div
                  className="flex flex-col md:flex-row items-center md:justify-between gap-6 md:gap-12 px-4 py-6 md:px-12 md:py-16 rounded-2xl h-full"
                  style={{ background: theme.reviews.reviewBackgroundColor }}
                >
                  <div className="flex flex-col items-center md:items-start gap-6 order-1 md:-order-1">
                    <p className="text-base text-center md:text-left md:text-2xl">{creatorReview}</p>
                    <div className="flex items-center gap-1 md:gap-3">
                      <img
                        src={creatorImage}
                        className="h-8 w-8 md:h-11 md:w-11 rounded-full"
                      />
                      <span className="italic text-sm md:text-xl font-semibold">
                        {creatorName}
                      </span>
                    </div>
                  </div>
                  <div className="h-48 w-48 md:h-[16.25rem] md:w-[16.25rem] shrink-0">
                    <img src={image} className="h-full w-full object-cover" />
                  </div>
                </div>
              </SwiperSlide>
            );
          })}
        </Swiper>
        <div ref={nextArrow} className="cursor-pointer h-6 w-6 md:h-9 md:w-9 shrink-0">
          <ChevronRightIcon className="text-[#5C5E5F] stroke-current h-full w-full"/>
        </div>
      </div>
    </section>
  );
}

export default ReviewSection;
